// extracted by mini-css-extract-plugin
export default {"content":"CaseFormBlock_content__MLM0W"};